import type { FetchAffiliateOrderReportFilterOptionsResponse } from 'Services/SalesManagement/Features/Report/types'
import { createBaseApi } from 'Util/ApiClient'

export const reportApi = createBaseApi({
  reducerPath: 'reportApi',
  keepUnusedDataFor: 10,
  tagTypes: []
}).injectEndpoints({
  endpoints: builder => ({
    getAffiliateOrderReportFilterOptions: builder.query<
      FetchAffiliateOrderReportFilterOptionsResponse,
      void
    >({
      query: () => ({
        url: '/api/v1/reports/affiliate-orders/sales/',
        method: 'OPTIONS'
      })
    })
  })
})

export const { useGetAffiliateOrderReportFilterOptionsQuery } = reportApi
